import { createCappie } from '@bldsoft/cappie/api/ovp'
import { restify, withObserve } from '@bldsoft/cappie/rest'
import { observe } from '@setplex/tria-api-adapter-ovp'
import { createOvpHttpClient } from './http'

export const ovpHttp = createOvpHttpClient()

export const { cappie: client } = createCappie({
  rest: restify(ovpHttp, withObserve(observe)),
})
